<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-08-30 11:32:48
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-08-30 17:13:55
-->
<template>
  <div>
   
    <div class="search-box">
             <div style="margin:0px 0 20px 20px; padding-top:20px;">
            <span  class="title"  @click="$router.push('/')">首页</span> >  <span class="title">咨询列表</span>
      </div>
      <div class="result-list" style="display: flex">
          
        <div class="result-menu-list">
          <a-menu>
            <a-sub-menu
              v-for="item in zh"
              :key="item.key"
              @titleClick="({ key, domEvent }) => handleClickTag(key)"
            >
              <span slot="title"
                ><a-icon type="mail" /><span>{{ item.value }}</span></span
              >
            </a-sub-menu>
          </a-menu>
        </div>
        <div style="display: flex; flex-direction: column">
          <div
            class="result-item"
            v-for="item in list"
            :key="item.id"
          >
            
            <div class="result-info" style="cursor: pointer;" @click="() =>$router.push({path: '/news',query: { id: item.id, type: 'news' },})"  :title="item.title"  >
              <h4><img src="../assets/img/lingxing.png" style="width:15px;height:15px"/>&nbsp;&nbsp;<a style="color:black">{{ subString(item.title)}}</a></h4>
            </div>
            <div class="result-time">
              <h4>发布时间:{{ item.createTime }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import request from "../util/request";
const defaultImg = require("../assets/default.png");
export default {
  name: "productSystem",
  
  data() {
    return {
      zh: [
        {key:1,value:"最新动态"},
         {key:2,value:"平台公告"}
      ],
      defaultImg,
      data: [],
      list: [],
      type: 1, 
    };
  },
  mounted() {
    this.queryList(this.type);
  },
  methods: {
    queryList(type) {
      request({
        url: "/api/client/common/news/list",
        method: "get",
        params: { page: 1, pageSize: 15,type:type },
      }).then((res) => {
        if (res.code == "200") {
          this.list = res.data;
        }
      });
    },
    subString(data) {
      if (data.length > 48) {
        return data.substring(0, 48);
      }
      return data;
    },
    handleClickTag(item) {
      this.queryList(item);
    },
  },
};
</script>
<style lang="less">
.search-box {
  width: 1280px;
  margin: 0 auto;
  background: #fff;
}
.result-list {
  background: #fff;
  .result-menu-list{
    width: 200px;
  }

  .result-item {
    padding: 20px;
    align-items: center;
    display: flex;
    height: 45px;
    border-bottom: 2px solid #f2f2f2;
    .avatar {
      width: 220px;
      height: 140px;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .result-info {
      margin-left: 20px;
      width: 600px;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .result-info-title {
        cursor: pointer
      }
      .result-info-link {
        color: #140a0aa9;
      }
    }
   
  }
}
</style>
